<template>
  <div>
    <delegation-rate-menu></delegation-rate-menu>

    <v-alert :value="groups.length === 0" type="info">{{ $t("settings.delegationRate.customDelegationRate.noCustomGroups") }} </v-alert>

    <v-expansion-panels multiple accordion>
      <v-expansion-panel :key="item.id" :lazy="true" v-for="item in groups">
        <v-expansion-panel-header style="border-bottom: blue 1px;">
          <h3>
            {{ $t("settings.delegationRate.customDelegationRate.ratesForGroup") }}
            <b>{{ item.name }}</b>
          </h3>
          ({{ item.count_rates }} {{ $t("settings.delegationRate.customDelegationRate.specialRates") }},
          {{ item.count_users }}
          {{ $t("settings.delegationRate.customDelegationRate.users") }}
          {{ item.child_group_names != null ? ", " + $t("settings.delegationRate.customDelegationRate.childGroups") + ": " + item.child_group_names : "" }})
        </v-expansion-panel-header>
        <v-expansion-panel-content class="grey lighten-4 pa-3">
          <custom-delegation-rate-content :id="item.id"> </custom-delegation-rate-content>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import DelegationRateMenu from "../../../components/Settings/DelegationRate/DelegationRateMenu.vue";
import CustomDelegationRateContent from "../../../components/Settings/DelegationRate/CustomDelegationRateContent.vue";

export default {
  name: "SettingsDelegationRateCustom",
  components: { CustomDelegationRateContent, DelegationRateMenu },
  data: () => ({
    groups: []
  }),
  methods: {
    load() {
      this.axios.get("settings/delegation-group/list").then(resp => {
        this.groups = resp.data;
      });
    }
  },
  created() {
    this.load();
  }
};
</script>

<style scoped></style>
